export default "__VITE_ASSET__CkkZyiE6__"